import { useState, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { Box } from '@mui/material';

import '../theme/jTheme.css';

/**
 * Fullscreen workspace layout — no AppBar, no gutter, no max-width.
 * Applies j-workspace CSS class for Jerny workspace visual styles.
 * Syncs j-workspace-vars + data-theme to document.body so portals inherit CSS vars without visual side effects.
 * Used by CurrentStatePage and other workspace pages.
 */
export default function WorkspaceLayout() {
    const [theme, setTheme] = useState('dark');

    const toggleTheme = () => {
        setTheme((prev) => (prev === 'dark' ? 'light' : 'dark'));
    };

    // Sync vars-only class + data-theme to body so portals (createPortal) inherit CSS vars
    useEffect(() => {
        document.body.classList.add('j-workspace-vars');
        document.body.setAttribute('data-theme', theme);
        return () => {
            document.body.classList.remove('j-workspace-vars');
            document.body.removeAttribute('data-theme');
        };
    }, [theme]);

    return (
        <Box
            id="workspace-layout-root"
            className="j-workspace"
            data-theme={theme}
            sx={{ display: 'flex', flexDirection: 'column', height: '100vh', overflow: 'hidden' }}
        >
            <Box id="workspace-layout-content" sx={{ flex: 1, minHeight: 0, overflow: 'hidden' }}>
                <Outlet context={{ theme, toggleTheme }} />
            </Box>
        </Box>
    );
}
